<form (ngSubmit)="submit()" [formGroup]="generatePromoCodesForm">
    <div style="width: 500px">
        <div class="title">Generate promo codes</div>

        <app-alert/>

        <div class="label">Scope</div>
        <select class="field" formControlName="promoCodeScope" required>
            <option *ngFor="let scope of scopes" [value]="scope">
                {{ scope }}
            </option>
        </select>

        <div *ngIf="currentScope() == PromoCodeScope.Public">
            <div class="label">Code</div>
            <input autofocus class="field" formControlName="code" type="text" style="text-transform: uppercase;">
        </div>

        <div class="label">Category</div>
        <select class="field" formControlName="category" required>
            <option value="">Choose category...</option>
            <option *ngFor="let category of promoCodeCategories()" [value]="category">
                {{ category }}
            </option>
        </select>

        <div class="label">Type</div>
        <select class="field" formControlName="type" required>
            <option value="">Choose type...</option>
            <option *ngFor="let type of promoCodeTypes()" [value]="type">
                {{ type }}
            </option>
        </select>

        <div *ngIf="currentScope() == PromoCodeScope.Private">
            <div class="label">Batch</div>
            <input autofocus class="field" formControlName="batch" required type="text">
        </div>

        <div class="label">Description</div>
        <input autofocus class="field" formControlName="description" required type="text">

        <div class="label">Expiration</div>
        <input autofocus class="field" formControlName="expiration" type="date">

        <div *ngIf="currentScope() == PromoCodeScope.Private">
            <div class="label">Count</div>
            <input autofocus class="field" formControlName="count" required type="number" [min]="0">
        </div>

        <button [disabled]="!generatePromoCodesForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">{{ currentScope() == PromoCodeScope.Private ? "Generate" : "Create" }}</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../../assets/img/spinner.svg"/>
        </button>

        <div class="promo-codes-container" *ngIf="promoCodes() != null">
            <p *ngFor="let promoCode of promoCodes()">
                {{ promoCode }}
            </p>
        </div>
    </div>
</form>